export enum LanguageEnum {
    ITALIAN = "IT",
    ENGLISH = "EN"
}